module.exports = __webpack_public_path__ + "img/instagram.cf2dc61c.svg";